export default __webpack_public_path__ + "16e6f3110123f24009c85444fa6631c1.png";